import { ReturnAppSettings } from "@redotech/redo-customer-portal-shared/settings";
import { ExternalShipmentTracker } from "@redotech/redo-model/trackable";
import { ExternalLink } from "@redotech/redo-web/link";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const DeliveryEstimate = memo(function DeliveryEstimate({
  delivery,
  pastPreTransit,
  settings,
  robustTracker,
}: {
  delivery: { isDelivered: boolean; date: Date | null };
  pastPreTransit: boolean;
  settings: ReturnAppSettings;
  robustTracker: ExternalShipmentTracker;
}) {
  if (
    !delivery.isDelivered &&
    pastPreTransit &&
    delivery.date &&
    settings.storeUrl !== "shopconzuri.myshopify.com"
  ) {
    return (
      <ExternalLink showIcon={false} url={robustTracker.public_url}>
        <Text fontSize="lg" fontWeight="semibold" textColor="secondary">
          Estimated Delivery
        </Text>
      </ExternalLink>
    );
  }
  return null;
});
